import TabsPage from '../TabsPage';

import Select from "components/Select";
import ButtonIconSelect from "components/ButtonIconSelect";
import Button from "components/Button";
import Table from "components/Table";

import { ReactComponent as SignatureTrueIcon } from 'icons/components/signatureTrue.svg';

import './index.less';
import './themes/default.less';

export default class Documents extends TabsPage {
    constructor(props) {
        super(props);

        this.tableMap = {
            createdTime: {
                label: "client.date",
                type: "dateTime",
            },
            createdBy: {
                label: "client.formed",
                type: "doctor",
            },
            domainId: {
                label: "login.clinic",
                type: "select",
                store: "clinics",
                nameKey: "name",
            },
            documentTemplateEntity: {
                label: "client.documentType",
                callback: this.renderNameCell.bind(this),
                /*key: "type",
                type: "select",
                size: 200,
                store: "documents",
                nameKey: "name",*/
            },
            sign: {
                label: "client.signature",
                callback: this.signCell.bind(this),
            },
            actions2: {
                label: "main.actions",
                size: 120,
                callback: this.renderButtonCell.bind(this),
                hideLabel: true,
            },
            actions: {
                label: "main.actions",
                size: 35,
                callback: this.renderActionCell.bind(this),
                hideLabel: true,
            },
        };

        this.state = {
            ...this.state,
            absol: false,
            items: [],
            itemsDoc: [],
            sort: "-createdTime",
            clinicId: this.props.clinicId
        };

    }

    componentDidMount() {
        this.refresh();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.clinicId !== prevState.clinicId) {
            this.state.clinicId = this.props.clinicId;
            this.refresh();
        }
    }

    onSortChange(sort) {
        this.state.sort = sort;
        this.refresh();
    }

    refresh() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();
        const { id } = this.props.info;
        const resp = await this._request.clientDocumentsHistory.getForClient(id, this.props.clinicId);
        const items = resp?.data || [];
        const respDoc = await this._request.documentTemplate.getDocument();
        const itemsDoc = respDoc?.data.sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })) || [];
        this.setState({ items, itemsDoc });
        this._helper.hideLoading();
    }

    async downloadDocument(imageUrl, imageName) {
        await this._request.files.downloadDocument(imageUrl, "test");
    }

    renderNameCell(value) {
        return value?.title;
    }

    renderActionCell(value, it, { signed, fileStorageEntity, id }) {

        const items = [];

        if (fileStorageEntity) {
            items.push({ name: "main.print", onClick: this.printDoc.bind(this, fileStorageEntity.source) });
            items.push({ name: "client.download", onClick: this.downloadDocument.bind(this, fileStorageEntity.source) });
        }

        items.push({ name: "client.deleteFile", onClick: this.deleteDocument.bind(this, id) });

        if (signed) {
            items.push({ line: true });
            items.push({ name: "client.removeSignature", onClick: this.onSignDeleteAdd.bind(this, id, false) });
        }

        return (<ButtonIconSelect
            translate={true}
            items={items}
        />);
    }

    signCell(value, map, { signed }) {
        return signed ? <div className="flex gap8">
            <SignatureTrueIcon />
            <span>{this.tr("client.signed")}</span>
        </div> : <div>-</div>;
    }

    printDoc(url) {
        this._helper.showPrintBox(url);
    }

    async deleteDocument(id) {
        this._helper.showLoading();
        await this._request.clientDocumentsHistory.delete(id);
        this._helper.hideLoading();
        this.refresh();
    }

    async createNewDocument(documentId) {
        const { itemsDoc, clinicId } = this.state;

        this._helper.showLoading();

        const el = itemsDoc.find(it => it.id === documentId);
        const resp = await this._request.jasperReports.getParams(el.jasperReportName);
        const paramsObj = resp?.data || [];

        this._helper.hideLoading();

        const data = {
            clientId: this.props.info.id,
            clinicId: clinicId,
            doctorId: this.props.info.doctorId,
        };

        if (paramsObj.length > 0 && paramsObj[0].params) {

            const info = {

                documentTemplateName: el.name,
                fileStorageName: paramsObj[0].name,
                domain: this._helper.getClinicNameById(clinicId),
                domainId: clinicId,
                clientId: this.props.info.id,
                signed: false,
                jasperDocumentParams: {}
            };

            Object.keys(paramsObj[0].params).forEach(it => {
                info.jasperDocumentParams[it] = data[it] + "";
            });

            this._helper.showLoading();

            await this._request.clientDocumentsHistory.create(info);

            this._helper.hideLoading();

            this.refresh();
        }

    }

    async onSignDeleteAdd(id, signed) {
        this._helper.showLoading();
        await this._request.clientDocumentsHistory.update(id, { signed: signed });
        this._helper.hideLoading();
        this.refresh();
    }

    renderButtonCell(value, map, { id, signed }) {
        return signed ? null : <Button
            type={"secondary"}
            size={"small"}
            label={"client.sign"}
            onClick={this.onSignDeleteAdd.bind(this, id, true)}
        />;
    }

    render() {
        const { sort, items, itemsDoc } = this.state;

        return (
            <div className="documents flex1 flex col gap16">
                <div className="flex between">
                    <div className="text blockTitle">
                        {this.tr("client.generDocuments")}
                    </div>
                    <div>
                        <Select
                            fixedHolder="client.generateDocument"
                            showLeftIcon={false}
                            translate={true}
                            items={itemsDoc}
                            labelKey="title"
                            onChange={this.createNewDocument.bind(this)}
                        />
                    </div>
                </div>
                <Table
                    map={this.tableMap}
                    items={items}
                    sort={sort}
                    onSortChange={this.onSortChange.bind(this)}
                />
            </div>
        );
    }
}
